import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  sublabel?: string;
  variant?: 'primary' | 'light';
  className?: string;
};
export function CTAButton({
  label,
  sublabel,
  variant = 'primary',
  className = ''
}: CTAButtonProps) {
  const base = 'group inline-flex w-full items-center justify-center gap-2 rounded-2xl px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide shadow-lg transition-transform duration-200 active:scale-[0.98] sm:text-lg';
  const styles = variant === 'primary' ? 'bg-teal-600 text-white shadow-teal-600/30 hover:bg-teal-700' : 'bg-white text-navy shadow-black/20 hover:bg-teal-50';
  return <div className={`w-full ${className}`} data-id="element-74" data-mp="2ysfe5cll0imu">
      <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`${base} ${styles}`} data-id="element-75" data-mp="3cp2kg5zfcl5f">
        <span data-id="element-76" data-mp="38m60oby5eizw">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-77" data-mp="19968aqb9dd74" />
      </a>
      {sublabel && <p className={`mt-3 text-center text-[11px] font-medium leading-relaxed sm:text-xs ${variant === 'primary' ? 'text-navy/60' : 'text-white/70'}`} data-id="element-78" data-mp="1i9kzu7etfoj2">
          {sublabel}
        </p>}
    </div>;
}
export const CTA_SUBLABEL = 'Instant download · One-time payment · Lifetime access · 7-day guarantee';